import { runtimeStyleIntent } from './intents';
import { StyleCache } from './StyleCache';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createStyleIntent(layer, createKey, createLazyStyles) {
    return (...args)=>{
        const key = createKey(...args);
        const cached = StyleCache.get(key);
        if (cached) {
            return cached;
        }
        const lazy = createLazyStyles(...args);
        lazy.key = key;
        lazy.layer = layer;
        const intent = runtimeStyleIntent(lazy);
        StyleCache.register(intent);
        return intent;
    };
}

//# sourceMappingURL=createStyleIntent.js.map